import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';

export const styles = makeStyles(theme => ({
  component: {
    textAlign: 'center',
  },
  dialogPaper: {
    maxWidth: 640,
    background: themeColor.modalBackground,
  },
  header: {
    backgroundColor: themeColor.white,
    height: '9vh',
    marginBottom: '5vh',
    fontSize: rem(1.125),
    borderBottom: `1px solid ${themeColor.secondaryLight}`,
  },
  spacing: {
    marginLeft: '1vw',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  icon: {
    borderRadius: '50%',
    width: '1.75rem',
    height: '1.75rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '1vw',
  },
  decision: {
    color: theme.palette.secondary.main,
  },
  title: {
    fontSize: rem(2),
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}));
